module.exports = __webpack_public_path__ + "img/depan.04118ac9.jpg";